import { MapTypeEnum } from "./mapTypeEnum";

export const DecodeMapTypeEnum = Object.freeze({
    r: MapTypeEnum.roadmap,
    t: MapTypeEnum.raster,
    s: MapTypeEnum.satellite,
    d: MapTypeEnum.map3d
})